export const FILE_PARTIAL_WORKER_NAME = 'filePartial';
export const FILE_STREAMING_WORKER_NAME = 'fileStreaming';

export const THRESHOLD = 10000;

export const IDB_DIR_HANDLE_KEY = 'indexed_db_directory_handle_key';

export const FILE_SYSTEM_ROUTES = {
  Partial: 'partial'
};
